import { detailImageSize, sizedAppImage } from './image-utils.js'
import { safeHttpUrl } from './config.js'

const warmedImages = new Set()
export const loadAppDetailPage = () => import('./detail.vue')

// 只预加载代码及已授权列表中返回的封面，不预读权限或缓存详情接口结果。
export function warmAppDetail(app) {
  loadAppDetailPage().catch(() => {})
  warmAppCover(app?.coverUrl)
}

export function warmAppCover(source) {
  const cover = safeHttpUrl(source)
  if (!cover || typeof Image === 'undefined') return
  const url = sizedAppImage(cover, detailImageSize())
  if (warmedImages.has(url)) return
  warmedImages.add(url)
  if (warmedImages.size > 32) warmedImages.delete(warmedImages.values().next().value)
  const image = new Image()
  image.decoding = 'async'; image.fetchPriority = 'low'; image.src = url
}
